export default __webpack_public_path__ + "static/media/hiddenimage.38306a5b.svg";